import { type Car } from '@prisma/client'
import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import { Button } from '#app/shared/ui/inputs/button/Button.js'
import {
  type WarrantyDurationTypes,
  type WarrantyTypes,
} from '../../../../../../types/enums'
import Warranty from '../warranty'

type Props = {
  warrantyChoice: {
    type: WarrantyTypes
    duration: WarrantyDurationTypes
  }
  setWarrantyChoice: (warrantyChoice: {
    type: WarrantyTypes
    duration: WarrantyDurationTypes
  }) => void
  setShowContact: (showContact: boolean) => void
  setOpen: (val: boolean) => void
  car: Car
}

export default function ContadoLeft({
  warrantyChoice,
  setWarrantyChoice,
  setShowContact,
  setOpen,
  car,
}: Props) {
  return (
    <div
      className={`
        flex-grow pt-[31px]

        xl:pl-[100px]
      `}
    >
      <p
        className={`
          max-w-[650px] text-h5-bold text-neutral-900

          xl:text-h3
        `}
      >
        En Gama Óptima confiamos plenamente en la calidad de nuestros vehículos,
        por eso ofrecemos una garantía de hasta 3 años.
      </p>
      <Warranty
        warrantyChoice={warrantyChoice}
        setWarrantyChoice={setWarrantyChoice}
        car={car as any}
      />

      <Spacer size="24px" />
      <p className="mt-4 text-base-medium text-neutral-500">
        *Cada uno de nuestros vehículos incluye una garantía de 1 año.
      </p>
      <Spacer size="36px" />

      <Button
        variant="primary"
        className="h-12 max-w-[110px] text-base-bold text-white"
        onClick={() => setShowContact(true)}
      >
        Siguiente
      </Button>

      <Spacer size="40px" />
      <p className="mt-4 text-base-medium text-neutral-500">
        ¿Tienes duda sobre cómo funciona la garantía?{' '}
        <button
          className="text-primary-600 underline"
          onClick={() => {
            setOpen(true)
          }}
        >
          Saber más
        </button>
      </p>
    </div>
  )
}
